import React, { Component } from 'react'
import phoneBlue from './images/phone-blue.png'
import phone from './images/phone.png'
import qqBlue from './images/qq-blue.png'
import qq from './images/qq.png'
import backTopBlue from './images/back-top-blue.png'
import backTop from './images/back-top.png'
import email from './images/email.png'
import emailBlue from './images/email-blue.png'

export  class BackTop extends Component {
    constructor(props){
        super(props)
        this.state={
            phoneActive:false,
            qqActive:false,
            emailActive:false,
            backTopActive:false
        }
    }

    componentDidMount(){
        var that = this;
        document.addEventListener('click',function(e){
              var target = e.target.parentElement.parentElement.parentElement;
              if(!(target.className === 'back-top')){
                that.setState({
                    phoneActive: false,
                    qqActive:false,
                    emailActive:false,
                    backTopActive:false
                });
              }
        })
    }

    onMouseEnter(type){
        if(type==='phone'){
            this.setState({
                phoneActive: true,
                qqActive:false,
                emailActive:false,
                backTopActive:false
            });
        }else if(type==='qq'){
            this.setState({
                qqActive: true,
                emailActive:false,
                backTopActive:false,
                phoneActive:false
            });
        }else if(type==='email'){
            this.setState({
                emailActive: true,
                backTopActive:false,
                phoneActive:false,
                qqActive:false
            });
        }else if(type==='backTop'){
            this.setState({
                backTopActive: true,
                qqActive:false,
                emailActive:false,
                phoneActive:false
            });
        }

    }

    handleClick(e){
        window.scrollTo(0,0);
    }

    render(){
        return (<div className='back-top'>
                <div className='back-item' onMouseEnter={()=>this.onMouseEnter('phone')} >
                    {(this.state.phoneActive?<img src={phoneBlue} alt='电话号码' />:<img src={phone} alt='电话号码' />)}
                    <div className='item-list' style={this.state.phoneActive? {display:'block'} : {}}>
                        <p>020-8200-0284</p>
                        <p>020-31601874</p>
                    </div>
                </div>
                <div className='back-item' onMouseEnter={()=>this.onMouseEnter('qq')} >
                    {(this.state.qqActive?<img src={qqBlue} alt='qq号码' />:<img src={qq} alt='qq号码' />)}
                    <div className='item-list' style={this.state.qqActive? {display:'block'} : {}}>
                        <p><a href='http://wpa.qq.com/msgrd?v=3&amp;uin=3308200945&amp;site=qq&amp;menu=yes&amp;from=message&amp;isappinstalled=0' target='_blank' rel="noopener noreferrer">3308-2009-45</a></p>
                        <p><a href='http://wpa.qq.com/msgrd?v=3&amp;uin=3132145990&amp;site=qq&amp;menu=yes&amp;from=message&amp;isappinstalled=0' target='_blank' rel="noopener noreferrer">3132-1459-90</a></p>
                    </div>
                </div>
                <div className='back-item' onMouseEnter={()=>this.onMouseEnter('email')}>
                    {(this.state.emailActive?<img src={emailBlue} alt='邮箱' />:<img src={email} alt='邮箱' />)}
                    <div className='item-list' style={this.state.emailActive? {display:'block'} : {}}>
                        <p><a href='mailto:zhaoxiuqing@56xyl.com'>zhaoxiuqing@56xyl.com</a></p>
                        <p><a href='mailto:liaoshuang@56xyl.com'>liaoshuang@56xyl.com</a></p>
                    </div>
                </div>
                <div className='back-item' onClick={()=>this.handleClick()} onMouseEnter={()=>this.onMouseEnter('backTop')} >
                    {(this.state.backTopActive?<img src={backTopBlue} alt='回到顶部' />:<img src={backTop} alt='回到顶部' />)}
                </div>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/backTop/index.js